import { Link } from 'react-router-dom';
import styles from './EventItem.module.css';
import FavoriteButton from './FavoritesButton';
import ImageWithPlaceholder from './ImageWithPlaceholder';
import { DateUtil } from '../utils/DateUtil';
import { EventModel } from '../models/EventModel';
import { formatPrice } from '../utils/PriceUtil';
import { useSharedState } from '../hooks/useSharedState';

interface EventItemProps {
    event: EventModel;
    reloadOnClick?: boolean;
    onClick?: () => void;
}

export default function EventItem ({event, reloadOnClick = false, onClick}: EventItemProps) {

    const [selectedCategories, ] = useSharedState('categories', '');
    const getCategoryToDisplay = (): string => {
        if(event.categories.length == 1) {
            return event.categories[0].name;
        }
        const filtered = event.categories.filter(c => selectedCategories.split(';').includes(c.name));
        if(filtered.length > 0) {
            return filtered[0] + " +" + (event.categories.length -1);
        }
        return event.categories[0].name + " +" + (event.categories.length -1);
    }

    return <div className={styles.eventItem}>
        <FavoriteButton eventId={event.id}/>
        <Link reloadDocument={reloadOnClick} onClick={onClick} to={"/details/" + event.id}><ImageWithPlaceholder className={styles.eventItemImg} src={event.imageUrl} alt={event.title}/></Link>
        <div className={styles.eventCategory} title={event.categories.map(c=>c.name).join(', ')} >{getCategoryToDisplay()}</div>
        <div className={styles.eventInfos}>
            <div><Link reloadDocument={reloadOnClick} onClick={onClick} to={"/details/" + event.id}><span className={styles.eventTileTitle}>{event.title}</span></Link></div>
            <div><Link reloadDocument={true} to={"/venue/" + event.locationName} className={styles.venueLink}>{event.locationName} {event.distance_m && <span> — {Math.round(Number.parseFloat(event.distance_m))}m</span>}</Link></div> 
            <div>{formatPrice(event.price)}</div>
            <div className={styles.eventDate}>{event.dates ? DateUtil.getDayNameInFrench(event.dates[0]?.date) + ' ' + DateUtil.convertToEST(event.dates[0]?.date, event.timeUnkown)/*map(d => getDayNameInFrench(d.date) + ' ' + convertToEST(d.date)).join(', ')*/ : ''}</div>
            <Link reloadDocument={reloadOnClick} onClick={onClick} to={"/details/" + event.id} className={styles.eventDetailsLink}>Détails</Link>
        </div>
        <br/>
        <br/>
    </div>;

}